// Dora frontend bundle entry point.
// Bundled with esbuild → internal/web/static/app.js (embedded via go:embed).

import "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import { renderMarkdown } from "./lib/markdown.js";
import { startThemeWatcher } from "./lib/theme.js";
import ThemeController from "./controllers/theme_controller.js";
import DurationController from "./controllers/duration_controller.js";
import RunStreamController from "./controllers/run_stream_controller.js";
import AutoRefreshController from "./controllers/auto_refresh_controller.js";
import FileAutocompleteController from "./controllers/file_autocomplete_controller.js";
import KeyboardController from "./controllers/keyboard_controller.js";
import SearchQueryController from "./controllers/search_query_controller.js";
import CmdPaletteController from "./controllers/cmd_palette_controller.js";
import NavController from "./controllers/nav_controller.js";
import CommentFormController from "./controllers/comment_form_controller.js";
import CopyController from "./controllers/copy_controller.js";
import ModelPickerController from "./controllers/model_picker_controller.js";
import SettingsPageController from "./controllers/settings_page_controller.js";

window.Dora = window.Dora || {};
window.Dora.renderMarkdown = renderMarkdown;

const app = Application.start();
app.register("theme", ThemeController);
app.register("duration", DurationController);
app.register("run-stream", RunStreamController);
app.register("auto-refresh", AutoRefreshController);
app.register("file-autocomplete", FileAutocompleteController);
app.register("keyboard", KeyboardController);
app.register("search-query", SearchQueryController);
app.register("cmd-palette", CmdPaletteController);
app.register("nav", NavController);
app.register("comment-form", CommentFormController);
app.register("copy", CopyController);
app.register("model-picker", ModelPickerController);
app.register("settings-page", SettingsPageController);

startThemeWatcher();

// Swap the ⌘ glyph for "Ctrl" on non-Mac platforms in every <kbd>
// chiclet. Server-rendered templates always use ⌘ since it's the
// shorter token; the runtime swap keeps Linux/Windows users from
// seeing a foreign symbol. Re-runs on every Turbo navigation because
// the swapped DOM is discarded by morph rendering when the server
// re-emits the original glyph.
function applyKbdPlatform() {
  const isMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || "");
  if (isMac) return;
  document.querySelectorAll("kbd").forEach((el) => {
    if (!el.textContent.includes("⌘")) return;
    // "⌘K" → "Ctrl K" (insert a space before the next visible char);
    // bare "⌘" → "Ctrl".
    el.textContent = el.textContent
      .replace(/⌘(\S)/g, "Ctrl $1")
      .replace(/⌘/g, "Ctrl");
  });
}
applyKbdPlatform();
document.addEventListener("turbo:load", applyKbdPlatform);
document.addEventListener("turbo:render", applyKbdPlatform);
